import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

type TPreAssembledBasket = 'default' | 'green' | 'mix' | 'every' | 'random' | 'premium' | 'top' | 'hiddenPremium' | 'hiddenTop'

const setParams = [
    'cm=10', 'menu=everyday', 'menu=premium', 'menu=mix', 'extra=green',
    'menu=top', 'is_hidden=true', 'av_in_hid=top', 'dishes',
];

const resolveParamsToType = (params: string) => {
    switch (params) {
        case 'menu=top':
            return 'top';
        case 'cm=10&menu=premium':
            return 'premium';
        case 'cm=10&menu=premium&extra=green':
            return 'green';
        case 'cm=10&menu=mix':
            return 'mix';
        case 'cm=10&menu=everyday':
            return 'every';
        case 'is_hidden=true&dishes':
            return 'hiddenPremium';
        case 'av_in_hid=top&dishes':
            return 'hiddenTop';
        default:
            return 'default';
    }
};

export const getPreAssembledType = (search: string): TPreAssembledBasket => {
    const params = new URLSearchParams(search);
    const filtredParams: string[] = [];

    setParams.forEach((param) => {
        const [key, value] = param.split('=');
        // @ts-ignore
        if (params.has(key, value)) {
            filtredParams.push(param);
        }
    });

    const type = resolveParamsToType(filtredParams.join('&'));
    return type;
};

/**
 * @param {*} props
 * @description хук смотрит с какми сетом открывается app
 * @returns TPreAssembledBasket = 'default' | 'green' | 'top' | 'every'
 */
export const usePreAssembledBasketType = (): TPreAssembledBasket => {
    const [type, setType] = useState<TPreAssembledBasket>('default');
    const { search } = useLocation();

    useEffect(
        () => {
            const result = getPreAssembledType(search);
            setType(result);
        },
        [search],
    );

    return type;
};


/*

НУЖНО ОПЕРДЕЛИТЬ СЕТЫ, И НА ВСЕ МУТАЦИИ ADD TO BASKET нужно убрать из игру query параметры

// EVERY
?cm=10&menu=everyday

// TOP 5
?cm=10

// GREEN
?cm=10&extra=green&menu=premium

cm=10 === set
menu=everyday | premium
extra=green

cm=10 TOP 5

cm=10 & menu=everyday EVERY

cm=10 & menu=premium & extra=green GREEN


1. Определить по урлу что у нас в нем
2. При взаимоде с add to basket убрать из урла параметры
3. Нужно сапоставить EE DATES с сетом
4. Нужно логика работы с периудом для сетов


https://elementaree.ru/basket/?date=2025-11-20
&dishes=3513.2928.4517.2365.3628&payment=recurrent&period=2025-11-17
&promo_code=BLFR04&utm_campaign=activation&utm_medium=crm&utm_source=tb

https://elementaree.ru/basket/?cm=10&date=2025-11-20
&menu=premium&payment=recurrent&period=2025-11-17
&promo_code=OLYA&utm_campaign=activation&utm_medium=crm

*/
